import React from 'react';

// Store pill matching the in-stock badges on product cards (no quantity).
const StoreBadge = ({ name }) => (
  <span className="inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full border bg-green-50 text-green-800 border-green-200">
    <span className="w-1.5 h-1.5 rounded-full bg-green-600" />
    {name}
  </span>
);

export default StoreBadge;
